import React, { Component } from 'react';
import { NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import classnames from 'classnames';
import ApplicationMenu from '../../../../components/common/ApplicationMenu';

class PromotionApplicationMenu extends Component {
    // Helper để tính toán số lượng mà không lặp code
    getFilteredCount = (filterFunc) => {
        // Luôn tính trên toàn bộ dữ liệu để số liệu chính xác
        return this.props.data.filter(filterFunc).length;
    };

    render() {
        const { data, filter, filterData } = this.props;

        if (!data) {
            return null; // An toàn nếu data chưa có
        }

        // --- Các hàm tính toán số lượng ---
        const now = new Date(); // Dùng một mốc thời gian chung cho tất cả các phép so sánh

        // 1. Trạng thái
        const countActive = this.getFilteredCount(p => 
            new Date(p.startDate) <= now && 
            new Date(p.endDate) >= now && 
            p.usageCount < p.maxUsageTotal
        );
        const countScheduled = this.getFilteredCount(p => new Date(p.startDate) > now);
        const countExpired = this.getFilteredCount(p => 
            new Date(p.endDate) < now || 
            p.usageCount >= p.maxUsageTotal
        );

        // 2. Lượt sử dụng
        const countOutOfStock = this.getFilteredCount(p => p.usageCount >= p.maxUsageTotal);
        const countLowStock = this.getFilteredCount(p => 
            p.maxUsageTotal > 0 && 
            ((p.maxUsageTotal - p.usageCount) / p.maxUsageTotal) * 100 <= 10
        );
        const countNeverUsed = this.getFilteredCount(p => p.usageCount === 0);

        // 3. Loại chương trình
        const countDiscountType = this.getFilteredCount(p => p.promotionType === 'DISCOUNT');
        const countGiftType = this.getFilteredCount(p => p.promotionType === 'GIFT');
        

        return (
            <ApplicationMenu>
                <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
                    <div className='p-4'>
                        <p className='text-muted text-small'>Lọc nhanh</p>
                        <ul className='list-unstyled mb-5'>
                            <NavItem className={classnames({ active: !filter || !filter.column })}>
                                <NavLink to='#' onClick={() => filterData('', '')} location={{}}>
                                    <span>Tất cả chương trình</span>
                                    <span className='float-right'>{data.length}</span>
                                </NavLink>
                            </NavItem>
                        </ul>

                        <p className='text-muted text-small'>Trạng thái</p>
                        <ul className='list-unstyled mb-5'>
                            <NavItem className={classnames({ active: filter && filter.column === 'promotion_status' && filter.value === 'active' })}>
                                <NavLink to='#' onClick={() => filterData('promotion_status', 'active')} location={{}}
                                    className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex align-items-center'>
                                        <i className='simple-icon-control-play' />
                                        <span>Đang diễn ra</span>
                                    </div>
                                    <span className='float-right'>{countActive}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ active: filter && filter.column === 'promotion_status' && filter.value === 'scheduled' })}>
                                <NavLink to='#' onClick={() => filterData('promotion_status', 'scheduled')} location={{}}
                                    className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex align-items-center'>
                                        <i className='simple-icon-calendar' /> <span>Sắp diễn ra</span>
                                    </div>
                                    <span className='float-right'>{countScheduled}</span>
                                </NavLink>
                            </NavItem>
                             <NavItem className={classnames({ active: filter && filter.column === 'promotion_status' && filter.value === 'expired' })}>
                                <NavLink to='#' onClick={() => filterData('promotion_status', 'expired')} location={{}}
                                    className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex align-items-center'>
                                        <i className='simple-icon-check text-muted' /> <span>Đã kết thúc</span>
                                    </div>
                                    <span className='float-right'>{countExpired}</span>
                                </NavLink>
                            </NavItem>
                        </ul>

                        <p className='text-muted text-small'>Lượt sử dụng</p>
                        <ul className='list-unstyled mb-5'>
                            <NavItem className={classnames({ active: filter && filter.column === 'usage_status' && filter.value === 'low_stock' })}>
                                <NavLink to='#' onClick={() => filterData('usage_status', 'low_stock')} location={{}}>
                                    <span>Còn dưới 10%</span>
                                    <span className='float-right'>{countLowStock}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ active: filter && filter.column === 'usage_status' && filter.value === 'out_of_stock' })}>
                                <NavLink to='#' onClick={() => filterData('usage_status', 'out_of_stock')} location={{}}>
                                    <span>Hết lượt sử dụng</span>
                                    <span className='float-right'>{countOutOfStock}</span>
                                </NavLink>
                            </NavItem>
                            <NavItem className={classnames({ active: filter && filter.column === 'usage_status' && filter.value === 'never_used' })}>
                                <NavLink to='#' onClick={() => filterData('usage_status', 'never_used')} location={{}}>
                                    <span>Chưa sử dụng</span>
                                    <span className='float-right'>{countNeverUsed}</span>
                                </NavLink>
                            </NavItem>
                        </ul>
                        
                        <p className='text-muted text-small'>Loại chương trình</p>
                        <ul className='list-unstyled mb-5'>
                             <NavItem className={classnames({ active: filter && filter.column === 'promotion_type' && filter.value === 'DISCOUNT' })}>
                                <NavLink to='#' onClick={() => filterData('promotion_type', 'DISCOUNT')} location={{}}>
                                    <span>Giảm giá</span>
                                    <span className='float-right'>{countDiscountType}</span>
                                </NavLink>
                            </NavItem>
                             <NavItem className={classnames({ active: filter && filter.column === 'promotion_type' && filter.value === 'GIFT' })}>
                                <NavLink to='#' onClick={() => filterData('promotion_type', 'GIFT')} location={{}}>
                                    <span>Tặng quà</span>
                                    <span className='float-right'>{countGiftType}</span>
                                </NavLink>
                            </NavItem>
                        </ul>
                    </div>
                </PerfectScrollbar>
            </ApplicationMenu>
        );
    }
}

export default PromotionApplicationMenu;